import { query } from '../utilities';

export const delivery = (data) => {
    return query('/delivery/', {
        data
    });
};
